// Module
var code = `<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="game_events.VisitDogTagsBattlePassChart"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="game_events.DogsTagsBattlePassCollectRewardCountChart"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="game_events.DogsTagsBattlePassGoldSpendCountChart"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="game_events.DogsTagsBattlePassBuyPremiumCountChart"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="game_events.DogsTagsBattlePassBuyPremiumCountByBattlePassTitleChart"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="game_events.DogsTagsBattlePassAverageIncomeByDateChart"></bfg-chart>
    </div>
</div>


<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="game_events.DogsTagsBattlePassAverageIncomeByBattlePassTitleChart"></bfg-chart>
    </div>
</div>
`;
// Exports
module.exports = code;